import { Chip, ChipProps } from "@mui/material";

export const isPatientVip = (isVip?: number | null | boolean) =>
  Number(isVip) === 1;

type PatientVipChipProps = {
  isVip?: number | null | boolean;
  size?: ChipProps["size"];
  className?: string;
  sx?: ChipProps["sx"];
};

const PatientVipChip = ({
  isVip,
  size = "small",
  className,
  sx,
}: PatientVipChipProps) => {
  if (!isPatientVip(isVip)) return null;

  return (
    <Chip
      label="VIP"
      color="secondary"
      size={size}
      className={className}
      sx={{ fontWeight: 700, ...sx }}
    />
  );
};

export default PatientVipChip;
